// Asana Custom Field Names
export const ASANA_CUSTOM_FIELDS = {
  STREET_NAME: 'Street', // Contains full address (e.g., "123 Main Street")
  CITY: 'City',
  STATE: 'State',
  ZIP_CODE: 'ZIP Code',
  UTILITY_NAME: 'Utility',
  CLIENT: 'Client', // Drives LGCY vs standard BOM workflow
  /** All possible field name variants for the client field across Asana and ClickUp */
  CLIENT_NAMES: ['Client', 'Client:'] as const,
  /** ClickUp-specific client field name */
  CLICKUP_CLIENT: '[GEN] Client',
  AHJ_NAMES: ['AHJ', 'AHJ-'] as const // Multiple possible field names for AHJ
} as const;